import type { IOrdinalOrderSettlementResponse } from 'api/api'
import { useOrdinalMarketRunStatus } from 'hooks/useOrdinalMarketRunStatus'

const SETTLEMENT_WORKFLOW_CLASS = 'AppTemporal::Workflows::OrdinalOrderSettlementWorkflow'
const SETTLEMENT_STATUS_TOPIC = 'ordinal_order_settlement_status'

/**
 * The narration of one ordinal sale settlement, for whichever surface started
 * it: the market rail's Buy/Accept or the owner's offer card. Settlement takes
 * real time — build, maybe wait on the buyer's funds, broadcast, record — and
 * the initiator reads its progress here. When it ends without a sale the
 * `settlement_failed` state event has already put the surface back into its
 * open shape, so the final message needs a home of its own: a toast.
 */
export function useOrdinalSettlementStatus() {
    const { message, trackRun } = useOrdinalMarketRunStatus({
        workflowClass: SETTLEMENT_WORKFLOW_CLASS,
        eventBusTopic: SETTLEMENT_STATUS_TOPIC,
        failureMessage: 'The sale could not complete.',
    })

    /** Follow the run a settle response started. */
    const trackSettlement: (response: IOrdinalOrderSettlementResponse | null | undefined) => void =
        trackRun

    return { settlementMessage: message, trackSettlement }
}
